import React from 'react';
import StatCardDisplay from './StatCardDisplay';
import TableDisplay from './TableDisplay';
import ChartDisplay from './ChartDisplay';

const ComponentRenderer = ({ component, customization }) => {
  const componentType = component.ComponentType || component.componentType;

  switch (componentType) {
    case 'StatCard':
      return <StatCardDisplay component={component} customization={customization} />;
    case 'Table':
      return <TableDisplay component={component} customization={customization} />;
    case 'BarChart':
    case 'LineChart':
    case 'PieChart':
      return <ChartDisplay component={component} customization={customization} />;
    default:
      return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 border border-gray-200 dark:border-gray-700">
          <div className="text-gray-500 dark:text-gray-400 text-center">
            Unsupported component type: {componentType}
          </div>
        </div>
      );
  }
};

export default ComponentRenderer;

